import { schema } from "normalizr"
import userLicenceModels from "../userRoles"
import licenceModule from "../licenceModules/item"

export default new schema.Entity(
  "licenceModuleDetails",
  {
    userLicenceModels,
    licenceModule,
  },
  {
    idAttribute: value => value.licenceModule.moduleLicenceId,
  }
)
